import { createFileRoute, redirect } from '@tanstack/react-router'
import { NOTIFICATION_VIEW_PERMISSION } from '@/features/notifications/api'
import { NotificationsScreen } from '@/features/notifications/notifications-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/notifications')({
  validateSearch: (search: Record<string, unknown>) => ({ page: Number(search.page ?? 1) }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, NOTIFICATION_VIEW_PERMISSION)) {
      throw redirect({ to: '/' })
    }
  },
  component: NotificationsScreen,
})
